/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
import { Layer } from './topology';
import { RandomSeed } from '../backend/random_seed';
let BaseRandomLayer = /*#__PURE__*/(() => {
  class BaseRandomLayer extends Layer {
    constructor(args) {
      super(args);
      this.randomGenerator = new RandomSeed(args.seed);
    }
    getConfig() {
      const config = {
        'seed': this.randomGenerator.seed
      };
      const baseConfig = super.getConfig();
      Object.assign(config, baseConfig);
      return config;
    }
  }
  // A layer handle the random number creation and savemodel behavior.
  /** @nocollapse */
  BaseRandomLayer.className = 'BaseRandomLayer';
  return BaseRandomLayer;
})();
export { BaseRandomLayer };
